module.exports = __webpack_public_path__ + "img/pager.528895db.png";